import React from "react";
import {  useLoaderData } from "react-router-dom";
import ServicesCard from "./ServicesCard";

const Services = () => {
  const services = useLoaderData();
  return (
    <>
      <div className="m-0 p-0  text-base">
        {services.map((service) => (
          <ServicesCard key={service._id} service={service}></ServicesCard>
        ))}
      </div>
     
    </>
  );
};

export default Services;
